module.exports = __webpack_public_path__ + "./img/CategoriasInicio.5d51ec9781afdf646ee77f380aca966c.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/CategoriasInicio.png
// module id = ./public/img/Help/CategoriasInicio.png
// module chunks = 0